///<reference path="../../shared/tool.service.ts"/>
import {Component, OnInit} from '@angular/core';
import {Register} from '../../shared';
import {ConfigService} from '../../../core/config';
import {MapDetailsToolOptions} from '../map-details-tool/map-details-tool.interface';
import {EtloutsideInfoService} from './etloutside-info.service';
import * as _moment from 'moment';
const moment = _moment;
@Register({
  name: 'homePage',
  title: 'igo.homePage',
  icon: 'home'
})
@Component({
  selector: 'igo-home-page',
  template: require('./home-page.component.html'),
  styles: [require('./home-page.component.styl')]
})
export class HomePageComponent implements OnInit {
  phases: String[]
  date: String;

  public options: MapDetailsToolOptions = {};

  constructor(private config: ConfigService, private etlOutsideService: EtloutsideInfoService) {
    this.phases = this.config.getConfig('homePage.phases') || {};
    this.etlOutsideService.getEtloutsideInfoEndTime()
      .subscribe(res => this.date = moment(res[0].endtime).format('YYYY/MM/DD'))
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/home-page/home-page.component.ts